import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router } from '@angular/router';

import { CapabilitiesService } from '../shared/shared-context/capabilities.service';
import { BaseRouteGuard } from './base.route-guard';

@Injectable({
    providedIn: 'root'
})
export class M365AppsRouteGuard extends BaseRouteGuard implements CanActivate, CanLoad {

    private readonly m365AppsNavigationEnabled: boolean;
    constructor(
        capabilitiesService: CapabilitiesService,
        router: Router
    ) {
        super(router, capabilitiesService);
        this.m365AppsNavigationEnabled = this.capabilitiesService.capabilities.leftNavReact && this.capabilitiesService.capabilities.m365AppsEnabled;
    }

    public canActivate() {
        return this.checkEnabledAndRedirect(this.m365AppsNavigationEnabled);
    }

    public canLoad() {
        return this.checkEnabledAndRedirect(this.m365AppsNavigationEnabled);
    }
}
